export const isIos = () => Boolean(navigator.userAgent.match(/iPhone|iPad/i));
export const isKakaoBrowser = () => Boolean(navigator.userAgent.match(/kakaotalk/i));
